// Planos disponíveis na plataforma AgendaPro
// Preços em BRL/mês. Enterprise = sob consulta (preco: null).

export const PLANS = [
  {
    id:                  'basico',
    nome:                'Básico',
    preco:               49,
    limiteColaboradores: 2,
    descricao:           'Ideal para pequenos estabelecimentos',
    destaques:           ['Até 2 colaboradores', 'Agendamentos ilimitados', 'Confirmação automática'],
  },
  {
    id:                  'intermediario',
    nome:                'Intermediário',
    preco:               99,
    limiteColaboradores: 5,
    descricao:           'Para equipes em crescimento',
    destaques:           ['Até 5 colaboradores', 'Controle financeiro', 'Relatórios mensais'],
  },
  {
    id:                  'master',
    nome:                'Master',
    preco:               199,
    limiteColaboradores: 10,
    descricao:           'Para clínicas consolidadas',
    destaques:           ['Até 10 colaboradores', 'Catálogo público', 'Suporte prioritário'],
  },
  {
    id:                  'enterprise',
    nome:                'Enterprise',
    preco:               null,
    limiteColaboradores: null,
    descricao:           'Equipe ilimitada — sob consulta',
    destaques:           ['Colaboradores ilimitados', 'Integrações customizadas', 'SLA dedicado'],
  },
];

export const ESTABLISHMENT_CATEGORIES = [
  { id: 'salao',       label: 'Salão de Beleza',      icon: '💇' },
  { id: 'estetica',    label: 'Clínica de Estética',   icon: '✨' },
  { id: 'odontologia', label: 'Clínica Odontológica',  icon: '🦷' },
  { id: 'medica',      label: 'Clínica Médica',        icon: '🏥' },
];

// ─── PLANOS DO PROFISSIONAL AUTÔNOMO ──────────────────────────────────────────
// Autônomo = profissional SEM estabelecimentoId (não vinculado a clínica).
// `limiteProcedimentos`: null = ilimitado. O limite é reforçado no cliente
// (regras do Firestore não conseguem contar documentos de uma coleção).
export const AUTONOMOUS_PLANS = [
  {
    id:                  'pro_basico',
    nome:                'Básico',
    preco:               15,
    limiteProcedimentos: 3,
    descricao:           'Para profissionais autônomos começarem',
    destaques:           ['Até 3 procedimentos', 'Agendamentos próprios', 'Chat com clientes'],
  },
  {
    id:                  'pro_plus',
    nome:                'Plus',
    preco:               29,
    limiteProcedimentos: 10,
    descricao:           'Para autônomos em crescimento',
    destaques:           ['Até 10 procedimentos', 'Agendamentos próprios', 'Chat com clientes'],
  },
  {
    id:                  'pro_ilimitado',
    nome:                'Ilimitado',
    preco:               49,
    limiteProcedimentos: null,
    descricao:           'Sem limite de procedimentos',
    destaques:           ['Procedimentos ilimitados', 'Agendamentos próprios', 'Chat com clientes'],
  },
];

export const DEFAULT_AUTONOMOUS_PLAN_ID = 'pro_basico';

/** Retorna o objeto do plano autônomo (default: Básico) a partir do planoId. */
export function getAutonomousPlan(planoId) {
  return AUTONOMOUS_PLANS.find(p => p.id === planoId) || AUTONOMOUS_PLANS[0];
}

/** Limite de procedimentos do plano autônomo. null = ilimitado. */
export function autonomousProcedureLimit(planoId) {
  return getAutonomousPlan(planoId).limiteProcedimentos;
}

// Compat: referência ao plano básico (antes era PLAN_PROFESSIONAL).
export const PLAN_PROFESSIONAL = AUTONOMOUS_PLANS[0];
